<template>
  <section id="lyricsContainer" class="lyricsContainer">
    <div class="closeLyricsContainer">
      <div class="closeLyrics" v-on:click="closeLyrics()">&#10005;</div>
    </div>
    <h3 id="lyricsTitle">{{ this.lyricsTitle }}</h3>
    <p id="lyrics" class="lyrics">
      {{ this.lyrics }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'LyricsContainer',
  props: ['lyricsTitle', 'lyrics'],
  methods: {
    closeLyrics() {
      this.$emit('closeLyrics');
    },
  },
};
</script>

<style scoped lang="scss">
.lyricsContainer {
  position: relative;
}
.lyrics {
  white-space: pre-line;
}

.closeLyricsContainer {
  text-align: right;
}
.closeLyrics {
  border: 1px solid rgba(0, 0, 0, 0);
  display: inline;
  font-size: 1.5em;
  cursor: pointer;
  &:hover {
    border: 1px solid #646154;
    border-radius: 5px;
  }
}
</style>
